import React from 'react';
import '../App.css';
import './HeroSection.css';
import Typewriter from 'typewriter-effect';

function HeroSection() {
  const all_hello_worlds = [
    'print("Hello World")',
    'std::cout << "Hello World";',
    'console.log("Hello World");',
    'println("Hello World");',
    'echo "Hello World"'
  ]
  // const downloadResume = () => {
  //   const a = document.createElement('a');
  //   // a.download = 'Soumyajit_Rout_Resume.pdf';
  //   a.href = 'Soumyajit_Rout_Resume.pdf';
  //   a.target='_blank';
  //   a.click();
  // };

  // var backgroundImageList = ['/images/background1.svg',   '/images/background4.svg', '/images/background2.svg'];
  var backgroundImageList = ['/images/background2.svg'];
  var backgroundImage = backgroundImageList[Math.floor(Math.random() * backgroundImageList.length)];

  return (
    <section id="home">
      <div className='hero-container'>
        <img src={backgroundImage} alt='background' className='background-image' />
        <div className="welcome-text">
          <h1><Typewriter
            options={{
              strings: all_hello_worlds,
              autoStart: true,
              loop: true,
              pauseFor: 2000,
              delay: 60
            }}
          /></h1>
          <h2>I'm <span className='code-font'>Soumyajit Rout</span></h2>
          <p>I am a Software Engineer from Bengaluru with expertise in Python, Go, Network Automation, Time Synchronization and AI-driven solutions, including RAG, Vector Databases, and LangChain.
             I build scalable systems that integrate software and hardware, tackling complex challenges through thoughtful engineering.
          </p>
          <p></p>


          <div className="social-icons">
            <a href="https://github.com/soum-sr" target="_blank" rel="noreferrer"><i class="fa-brands fa-github"></i></a>
            <a href="https://www.linkedin.com/in/soumyajitrout/" target="_blank" rel="noreferrer"><i class="fa-brands fa-linkedin"></i></a>
            <a href="https://stackoverflow.com/users/11289239/soumyajit" target="_blank" rel="noreferrer"><i class="fa-brands fa-stack-overflow"></i></a>
            <a href="https://medium.com/@soum1071" target="_blank" rel="noreferrer"><i class="fa-brands fa-medium"></i></a>
            <a href="mailto:soum1071@gmail.com" target="_blank" rel="noreferrer"><i class="fa-solid fa-envelope"></i></a>
          </div>


        </div>
      </div>
    </section>
  );
}

export default HeroSection;